module.exports = __webpack_public_path__ + "video/200_KMSAT15_2022_Introduction.064b412f.vtt";